import React, { useState } from "react";
import { FaPhone } from "react-icons/fa";
import "./CallButton.css";

const CallButton = () => {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      {/* Call Button & Popup */}
      <div
        className={`call-btn ${showPopup ? "call-btn--active" : ""}`}
        onClick={() => setShowPopup(!showPopup)}
      >
        <FaPhone className="call-btn__icon" />
      </div>
      {showPopup && (
        <div className={`call-btn__popup ${showPopup ? "call-btn__popup--visible" : ""}`}>
          <p className="call-btn__popup-heading">Need Help? Call !</p>
          <a 
            className="call-btn__link"
            href="tel:+917007512120"
          >
            <span className="call-btn__number">
              +91 7007512120
            </span> 
            <span className="call-btn__pointer">👈</span>
          </a>
        </div>
      )}
    </>
  );
};

export default CallButton;